<template>
  <div>
    <div class="inputBox shadow animated bounceIn">
      <input type="text" v-model="newTodoItem" placeholder="Add What You Have TODO" v-on:keyup.enter="addTodo">
      <span class='addContainer' v-on:click="addTodo">
        <i class="addBtn fas fa-plus" aria-hidden="true"></i>
      </span>
    </div>

    <modal v-if="showModal" @close="showModal=false">
      <h3 slot="header">경고!</h3>
      <span slot="body"  @click="showModal=false">
        할 일을 입력하세요!!
        <i class="closeModalBtn fas fa-times" aria-hidden="true"></i>
      </span>
    </modal>

  </div>
</template>

<script>
import Modal from './common/Modal.vue'

export default {
  data() {
    return {
      newTodoItem : '',
      showModal : false
    }
  },
  methods : {
    addTodo() {
      const text = this.newTodoItem.trim();
      if(text && text != null && text != '') {
        this.$store.commit('addTodo', text);
        this.clearInput();
      }
      else
        this.showModal  = !this.showModal;
    },
    clearInput() {
      this.newTodoItem = '';
    }
  },
  components : {
    Modal
  }
}
</script>

<style scoped>
  input:focus {
    outline: none;
  }
  .inputBox {
    background: white;
    height : 50px;
    line-height: 50px;
    border-radius: 5px;
  }
  .inputBox input {
    border-style: none;
    font-size: 0.9rem;
  }
  .addContainer {
    float : right;
    background: linear-gradient(to right, #6578FB, #8763FB);
    display : block;
    width : 3rem;
    border-radius: 0 5px 5px 0;
  }
  .addBtn {
    color : white;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/TodoInput.vue